<template>
    <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
        <b-form v-if="request" @submit.prevent="handleSubmit(send())">
            <div class="block-flat">
                <div class="header">
                    <h3>Attestation</h3>
                </div>

                <div class="block-content">
                    <b-form-group>
                        <b-form-group>
                            <b-row>
                                <b-col lg="2" class="hidden-md hidden-sm hidden-xs no-padding">
                                    <label class="control-label"></label>
                                </b-col>
                                <b-col lg="10" md="12" sm="12" cols="12">
                                    <ValidationProvider
                                            mode="lazy"
                                            v-slot="{ errors }"
                                            rules="required"
                                            name="l'exactitude des informations fournies"
                                    >
                                        <b-form-checkbox
                                                :state="errors[0] ? false : null"
                                                v-model="request.accuracyInformation"
                                        >
                                            J'atteste de l'exactitude des informations fournies
                                            <span class="red">*</span></b-form-checkbox
                                        >
                                        <div class="error">{{ errors[0] }}</div>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </b-form-group>
                        <b-form-group>
                            <b-row>
                                <b-col xl="2" lg="2" md="6" sm="12" cols="12">
                                    <label class="control-label"
                                    >Fait à <span class="red">*</span> :</label
                                    >
                                </b-col>
                                <b-col xl="4" lg="3" md="6" sm="12" cols="12">
                                    <ValidationProvider
                                            mode="lazy"
                                            v-slot="{ errors }"
                                            rules="required"
                                            name="fait à"
                                    >
                                        <b-form-input
                                                :state="errors[0] ? false : null"
                                                v-model="request.madeIn"
                                        />
                                        <div class="error">{{ errors[0] }}</div>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xl="2" lg="2" md="6" sm="12" cols="12">
                                    <label class="control-label">Le :</label>
                                </b-col>
                                <b-col xl="4" lg="5" md="6" sm="12" cols="12">
                                    <b-form-datepicker
                                            :start-weekday="1"
                                            hide-header
                                            disabled
                                            v-model="request.madeDate"
                                            placeholder="Selectionnez une date"
                                    ></b-form-datepicker>
                                </b-col>
                            </b-row>
                        </b-form-group>
                        <b-form-group>
                            <b-row>
                                <b-col lg="2" md="6" sm="12" cols="12">
                                    <label class="control-label"
                                    >Nom <span class="red">*</span> :</label
                                    >
                                </b-col>
                                <b-col lg="2" md="6" sm="12" cols="12">
                                    <ValidationProvider
                                            mode="lazy"
                                            v-slot="{ errors }"
                                            rules="required"
                                            name="nom"
                                    >
                                        <b-form-input
                                                :state="errors[0] ? false : null"
                                                v-model="request.madeLastName"
                                                placeholder="Merci de renseigner votre nom."
                                        />
                                        <div class="error">{{ errors[0] }}</div>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="2" md="6" sm="12" cols="12">
                                    <label class="control-label"
                                    >Prénom <span class="red">*</span> :</label
                                    >
                                </b-col>
                                <b-col lg="2" md="6" sm="12" cols="12">
                                    <ValidationProvider
                                            mode="lazy"
                                            v-slot="{ errors }"
                                            rules="required"
                                            name="prénom"
                                    >
                                        <b-form-input
                                                :state="errors[0] ? false : null"
                                                v-model="request.madeFirstName"
                                                placeholder="Merci de renseigner votre prénom."
                                        />
                                        <div class="error">{{ errors[0] }}</div>
                                    </ValidationProvider>
                                </b-col>
                                <b-col lg="2" md="6" sm="12" cols="12">
                                    <label class="control-label"
                                    >Qualité <span class="red">*</span> :</label
                                    >
                                </b-col>
                                <b-col lg="2" md="6" sm="12" cols="12">
                                    <ValidationProvider
                                            mode="lazy"
                                            v-slot="{ errors }"
                                            rules="required"
                                            name="qualité"
                                    >
                                        <b-form-input
                                                :state="errors[0] ? false : null"
                                                v-model="request.madeFonction"
                                                placeholder="Qualité"
                                        />
                                        <div class="error">{{ errors[0] }}</div>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-form-group>
                </div>
            </div>
            <div class="stepper-control">
                <b-button
                        variant="white"
                        @click="previous"
                        class="btn marginRight-10 marginBottom-15"
                >
                    <font-awesome-icon
                            icon="caret-left"
                            class="marginRight-5"
                    ></font-awesome-icon>
                    Précédent
                </b-button>
                <b-button type="submit" variant="primary" class="marginBottom-15">
                    <span>Terminer</span>
                    <font-awesome-icon
                            icon="caret-right"
                            class="marginLeft-5"
                    ></font-awesome-icon>
                </b-button>
            </div>
        </b-form>
    </ValidationObserver>
</template>

<script>
    import Vuex from "vuex";
    export default {
        props: ["value"],
        name: "Attestation",
        mounted() {
            var today = new Date();
            this.request.madeDate =
                today.getFullYear() +
                "-" +
                (today.getMonth() + 1) +
                "-" +
                today.getDate();
            this.request.madeFirstName = this.userConnected.firstName;
            this.request.madeLastName = this.userConnected.lastName;
            this.request.madeFonction = this.userConnected.quality;
        },
        computed: {
            request: {
                get: function() {
                    return this.dossierSelected;
                },
                set: function(newValue) {
                    this.setDossier(newValue);
                },
            },
            ...Vuex.mapGetters("Authentification", ["userConnected"]),
            ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
        },
        methods: {
            ...Vuex.mapGetters("Dossiers", ["setDossier"]),
            previous() {
                this.$emit("previous");
            },
            send() {
                this.$refs.formObserver.validate().then((success) => {
                    if (success == true) {
                        this.$emit("submit");
                    } else {
                        this.$emit("error", "Veuillez corriger les erreurs du formulaire");
                    }
                });
            },
        },
    };
</script>

<style scoped></style>
